import {ErrorMessageAlert} from './index';
import {useEffect, useState} from 'react';
import {getFlash} from "../../utils/storage-utils";
import {REDIRECT_FAILED} from "../../constants/app";

const RedirectAlert = ({className}) => {
    const [errorMessage, setErrorMessage] = useState(null);
    useEffect(() => {
        const message = getFlash(REDIRECT_FAILED);
        if (message) {
            setErrorMessage(message);
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    },[]);
    const alertClassName = `mb-[16px] ${className || ''}`;
    return (
      <ErrorMessageAlert className={alertClassName} error={errorMessage} />
    );
};

export default RedirectAlert;